import { ColDef, ICellRendererParams } from "ag-grid-community";

// Define the interface for the data structure
interface UserData {
  code: number;
  Code: number;
  Name: string;
  IsActive: boolean;
  UserTypeID: number;
  UserType: string;
}

interface ColumnDefsProps {
  onEdit: (data: UserData) => void;
  onDelete: (data: UserData) => void;
}

export const columnDefs = ({
  onEdit,
  onDelete,
}: ColumnDefsProps): ColDef<UserData>[] => [
  {
    headerName: "Name",
    field: "Name",
    sortable: true,
    filter: "agTextColumnFilter",
    flex: 1,
  },
  {
    headerName: "User Type",
    field: "UserType",
    sortable: true,
    filter: "agTextColumnFilter",
    flex: 1,
  },
  {
    headerName: "Active",
    field: "IsActive",
    sortable: true,
    filter: "agTextColumnFilter",
    flex: 1,
    cellRenderer: (params: ICellRendererParams<UserData>) => {
      const { value } = params;
      return (
        <span
          className={`badge ${
            value ? "bg-success" : "bg-danger"
          } text-white px-2 py-1 rounded`}
          style={{ fontSize: "0.8rem" }}
        >
          {value ? "Active" : "Inactive"}
        </span>
      );
    },
  },

  {
    headerName: "Actions",
    field: "Code",
    sortable: false,
    filter: false,
    width: 120,
    pinned: "right",
    lockPosition: true,
    suppressMovable: true,
    cellRenderer: (params: ICellRendererParams<UserData>) => {
      const { data } = params;
      return (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <button
              className="me-2 p-2 btn btn-sm btn-primary"
              onClick={() => data && onEdit(data)}
            >
              <i data-feather="edit" className="feather-edit"></i>
            </button>

            <button
              className="p-2 btn btn-sm btn-danger"
              onClick={() => data && onDelete(data)}
            >
              <i data-feather="trash-2" className="feather-trash-2"></i>
            </button>
          </div>
        </div>
      );
    },
  },
];
